import React, { useEffect, useState } from "react";
import DynamicTable from "../../../Components/InputComponents/LookupView";
import { Edit, Delete, Visibility } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { axiosAPI } from "../../../Components/AxiosComponents/Axios";
import { encryptId } from "../../../Components/CryptoComponent";

function YearsOfExperienceList() {
  const navigate = useNavigate();
  const columns = [
    { field: "YEL_Id", label: "#" },
    { field: "YEL_Name", label: "Years of Experience" },
    { field: "YEL_Status", label: "Status" },
  ];

  const [searchParams] = useSearchParams();

  const actions = [
    {
      icon: Edit,
      handler: (row) => {
        const encrypted = encodeURIComponent(encryptId(row?.YEL_Id));

        navigate(
          `/YearsOfExperienceLookup/Edit/${encrypted}?${searchParams.toString()}`
        );
      },
      color: "warning",
    },
  ];

  return (
    <DynamicTable
      columns={columns}
      actions={actions}
      dataAPI={`/YearofExp/list`}
      title={`Years of Experience`}
      linkvalue={`/YearsOfExperienceLookup/Add?${searchParams.toString()}`}
    />
  );
}

export default YearsOfExperienceList;
